import i18n from '@risksmart-app/i18n/src/i18n';

/**
 * Narrow `string -> string` binding of i18next's `t`, for use by the form-config
 * modules in this directory.
 *
 * tsgo (the TypeScript 7 native compiler) exceeds its type-instantiation-depth
 * budget when it resolves i18next's fully-typed `t` (a ~14k-key union plus the
 * `returnObjects: true` recursion) inside a large consuming program such as
 * `@risksmart-app/rest-api`, which compiles these form-config files from source
 * via its path aliases. That produces `TS2589: Type instantiation is excessively
 * deep and possibly infinite` at every `i18n.t(...)` call — but only in the large
 * program; `@risksmart-app/shared`'s own typecheck stays under budget.
 *
 * Exposing a single narrow signature keeps the deep typed-key overload from being
 * instantiated at each of the ~30 call sites. Translation keys remain validated by
 * `@risksmart-app/i18n`'s own typecheck and by runtime tests. The same tsgo
 * limitation is handled in rest-api's `src/adapters/aggregation-adapter.ts`.
 */
// Narrow cast (see doc comment above): works around tsgo TS2589 on i18next's typed `t`.
export const t = i18n.t as (key: string) => string;
